// ============================================================================
// REGROUP TRANSACTION ENDPOINTS
// ============================================================================

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/lmms/v1/regroup';

export const regroupEndpoints = {
  list: () => buildEndpoint(BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  create: () => buildEndpoint(BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  submit: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id/submit`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  search: (searchTerm: string) => `${buildEndpoint(BASE_PATH)}/search?searchTerm=${encodeURIComponent(searchTerm)}`,
  calculate: () => `${buildEndpoint(BASE_PATH)}/calculate`,
} as const;

export default regroupEndpoints;
